import ErrorFeedback from 'Components/ErrorFeedback'
import { STORE_KEY_ACCOUNT } from 'Constants/'
import { storeGet } from 'Helpers/localStorage'
import useModalSmsSender from 'Hooks/useModalSmsSender/useModalSmsSender'
import { evalCondition } from 'mailup-react-helpers'
import {
  Flex,
  Loading,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import Description from './components/Description'
import FooterButton from './components/FooterButton'
import InfoMessageDescriptionNoGuest from './components/InfoMessageDescriptionNoGuest'
import LinkNewSmsAlias from './components/LinkNewSmsAlias'
import SmsAliasTable from './components/SmsAliasTable'

export const CASE_0 = 0 // valore iniziale
export const CASE_1 = 1 // la finestra è in loading
export const CASE_2 = 2 // Items.length > 0
export const CASE_3 = 3 // Items.length > 0 && co:SMSALIAS AND uo:SETTINGS
export const CASE_4 = 4 // isTrial
export const CASE_5 = 5 // Items.length == 0
export const CASE_6 = 6 // Items.length == 0 && NOT uo:SETTINGS

export const MAX_ITEMS = 5

const ModalSmsSender = ({ show, handleCancel, handleConfirm }) => {
  const intl = useIntl()
  const {
    items: senderItems,
    loading,
    loaded,
    error,
    errMessage,
    severity
  } = useModalSmsSender()
  const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)
  const [caseState, setCaseState] = useState(CASE_0)

  const setCase = () => {
    if (IsTrial) {
      // caso 4
      setCaseState(CASE_4)
    } else {
      if (senderItems.Items.length > 0) {
        // caso 2/3
        if (evalCondition('NOT uo:SETTINGS')) {
          setCaseState(CASE_3)
        } else {
          setCaseState(CASE_2)
        }
      } else {
        // caso 5 e 6
        if (evalCondition('NOT uo:SETTINGS')) {
          setCaseState(CASE_6)
        } else {
          setCaseState(CASE_5)
        }
      }
    }
  }

  useEffect(() => {
    senderItems && senderItems.Items && setCase()
  }, [senderItems])

  const isScrollable =
    senderItems && senderItems.Items && senderItems.Items.length > MAX_ITEMS

  return (
    <>
      <Modal
        data-mu-test='modal-sms-sender'
        show={show}
        showClose
        onClose={handleCancel}
        closeOnOverlayClick
        size={MODAL_SIZE_MD}
      >
        <ModalHead
          title={intl.formatMessage({
            id: 'Load.WarningAliasSms.MadalSendersTitle'
          })}
        />
        <ModalBody data-mu-test='modal-sms-sender' scrollable={isScrollable}>
          <Flex
            height={isScrollable ? '400px' : 'auto'}
            flexDirection='column'
            rowGap='24px'
          >
            {/* caso 1 */}
            <Loading open={loading} />
            <ErrorFeedback error={errMessage} severity={severity} />
            {/* caso 2/3/4/5/6 */}
            {!error && loaded && caseState !== CASE_0 && (
              <>
                <Description
                  caseState={caseState}
                  isTrial={IsTrial}
                  items={senderItems.Items}
                />
                {(caseState === CASE_2 || caseState === CASE_3) && (
                  <Flex flexDirection='column' rowGap='8px'>
                    <SmsAliasTable
                      caseState={caseState}
                      isTrial={IsTrial}
                      items={senderItems.Items}
                    />
                    <LinkNewSmsAlias caseState={caseState} />
                  </Flex>
                )}

                <InfoMessageDescriptionNoGuest
                  caseState={caseState}
                  isTrial={IsTrial}
                  items={senderItems.Items}
                />
              </>
            )}
          </Flex>
        </ModalBody>
        <ModalFoot>
          {loaded && caseState !== CASE_0 && (
            <FooterButton
              caseState={caseState}
              isTrial={IsTrial}
              items={senderItems.Items}
              handleCancel={handleCancel}
              handleConfirmCallback={handleConfirm}
            />
          )}
        </ModalFoot>
      </Modal>
    </>
  )
}

ModalSmsSender.propTypes = {
  show: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func
}

export default ModalSmsSender
